import axios from "axios";
import { useEffect, useState } from "react";
import { appUrl } from "../../../../../../utils/config";
import BatchTable from "./BatchTable";
import Ribbon from "./Ribbon";
import { convertToLocaleDateTime } from "../../functionalComponents/FormatDateTimeToLocale";
import moment from "moment";

const useBatchDetails = (filter, vendorData) => {
  const [batchDetails, setBatchDetails] = useState(null);
  const [batchError, setBatchError] = useState(null);
  const [batchLoading, setBatchLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [saveDialog, setSaveDialog] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [selectedReasons, setSelectedReasons] = useState({});

  // track changes for select reason drop down
  const [initialSelectedReasons, setInitialSelectedReasons] = useState({});
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (filter) {
      // Ensure filter is not default
      fetchBatchDetails();
    }
  }, [filter, refresh]);

  useEffect(() => {}, [selectedReasons, filter]);

  const fetchBatchDetails = () => {
    setBatchLoading(true);
    setBatchError(null);
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/reconcileInventory/${vendorData.vendorPlant.plantCode}/${vendorData.vendorPlant.vendorMosymphonyID}`;
    // const url = `https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/reconcileInventory`;
    axios
      .get(url)
      .then((res) => {
        // throw new Error("Something went wrong");
        if (res.data.status) {
          setApiData(res.data.data.reconciliationData); //(JSON.parse(mockData));
          transformData(res.data.data.reconciliationData); //(JSON.parse(mockData));
        } else {
          setBatchError(res.data.message);
        }
      })
      .catch((err) => {
        setBatchError(err.message);
        setSaveDialog("error");
        console.error(err);
      })
      .finally(() => {
        setBatchLoading(false);
      });
  };

  // Re-process data whenever API data or filter changes
  useEffect(() => {
    if (apiData) {
      transformData(apiData);
    }
  }, [apiData, filter]); // Added filter as a dependency

  const handleReason = (index, event) => {
    const { value } = event.target;

    setSelectedReasons((prev) => ({
      ...prev,
      [index]: value,
    }));
  };

  //  Use `useEffect` to detect changes AFTER `selectedReasons` updates
  useEffect(() => {
    const hasChangesNow =
      JSON.stringify(selectedReasons) !==
      JSON.stringify(initialSelectedReasons);
    setHasChanges(hasChangesNow);
  }, [selectedReasons, initialSelectedReasons]);

  const handleSave = () => {
    if (!hasChanges) return;

    // Check if apiData and reconciliationDetailsList exist
    if (!apiData || !apiData.reconciliationDetailsList) {
      console.error('Cannot save: apiData or reconciliationDetailsList is undefined');
      setSaveDialog("error");
      setBatchError("Invalid data structure for saving");
      return;
    }

    setBatchLoading(true);
    setBatchError(null);
    // const url = `https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/updateInventoryReconciliation`;
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateInventoryReconciliation`;

    const reconciliationDataRequest = {
      vendorMosymphonyID: apiData?.vendorMosymphonyID || "NA",
      brandOwnerMosymphonyID: apiData?.brandOwnerMosymphonyID || "NA",
      vendorPlant: apiData?.vendorPlant || "NA",
      reconciliationDetailsList: apiData?.reconciliationDetailsList.map(
        (materialItem) => ({
          boMaterialCode: materialItem.boMaterialCode,
          cmoMaterialCode: materialItem.cmoMaterialCode,
          materialDescription: materialItem.materialDescription,
          inventoryUOM: materialItem.inventoryUOM,
          // lotNumberDetailsList: materialItem.lotNumberDetailsList.map((lot) => {
          //   const payloadLot = {
          //     sponsorLotNumber: lot.sponsorLotNumber,
          //     cmoLotNumber: lot.cmoLotNumber,
          //     sponsorOnHandAvailableQuantity:
          //       lot.sponsorOnHandAvailableQuantity,
          //     sponsorCommittedQuantity: lot.sponsorCommittedQuantity,
          //     cmoCommittedQuantity: lot.cmoCommittedQuantity,
          //     cmoOnHandAvailableQuantity: lot.cmoOnHandAvailableQuantity,
          //     onHandQuantityDifference: lot.onHandQuantityDifference,
          //     committedQuantityDifference: lot.committedQuantityDifference,
          //     cmoInventoryUploadDate: lot.cmoInventoryUploadDate || "NA",
          //     storageLocationID: lot.storageLocationID || "NA",
          //   };
          //   // Conditionally add reasonForDifference if present in selectedReasons
          //   // if (selectedReasons[lot.sponsorLotNumber]) {
          //   //   payloadLot.reasonForDifference =
          //   //     selectedReasons[lot.sponsorLotNumber];
          //   // }

          //   const updatedReason = selectedReasons[lot.sponsorLotNumber];
          //   if (
          //     updatedReason &&
          //     updatedReason !== lot.reasonForDifference
          //   ) {
          //     payloadLot.reasonForDifference = updatedReason;
          //   }
          //   return payloadLot;
          // }),

          lotNumberDetailsList: materialItem.lotNumberDetailsList
  .filter((lot) => {
    const updatedReason = selectedReasons[lot.sponsorLotNumber];
    return (
      updatedReason &&
      updatedReason !== lot.reasonForDifference
    );
  })
  .map((lot) => ({
    sponsorLotNumber: lot.sponsorLotNumber,
    cmoLotNumber: lot.cmoLotNumber,
    sponsorOnHandAvailableQuantity: lot.sponsorOnHandAvailableQuantity,
    sponsorCommittedQuantity: lot.sponsorCommittedQuantity,
    cmoCommittedQuantity: lot.cmoCommittedQuantity,
    cmoOnHandAvailableQuantity: lot.cmoOnHandAvailableQuantity,
    onHandQuantityDifference: lot.onHandQuantityDifference,
    committedQuantityDifference: lot.committedQuantityDifference,
    cmoInventoryUploadDate: lot.cmoInventoryUploadDate || "NA",
    storageLocationID: lot.storageLocationID || "NA",
    reasonForDifference: selectedReasons[lot.sponsorLotNumber], // updated value
  })),

        })
      ),
    };

    axios
      .post(url, reconciliationDataRequest)
      .then((res) => {
        if (res.data.status) {
          setSaveDialog("success");
          setRefresh((prev) => !prev);
          setInitialSelectedReasons(selectedReasons);
          setHasChanges(false);
        } else {
          setSaveDialog("error");
          setBatchError(res.data.message);
          console.error("Save Error:", res.data.message);
        }
      })
      .catch((err) => {
        setSaveDialog("error");
        setBatchError(err.message);
        console.error("Save Error:", err);
      })
      .finally(() => {
        setBatchLoading(false);
      });
  };

  const transformData = (reconciliationData) => {
    // Check if reconciliationData and reconciliationDetailsList exist
    if (!reconciliationData || !reconciliationData.reconciliationDetailsList) {
      console.warn('reconciliationData or reconciliationDetailsList is undefined');
      setBatchDetails([]);
      return;
    }

    let initialSelectedReasons = {};
    const transformedData = reconciliationData.reconciliationDetailsList.map(
      //reconciliationData.reconciliationData.reconciliationDetailsList.map(
      (item) => {
        // Modify each lot object to include percentage calculations
        const updatedLotNumberDetailsList = item.lotNumberDetailsList.map(
          (lot) => {
            let reason = lot?.reasonForDifference;
            if (reason) {
              //If reason is provided by API, use it for initial selectedReasons
              initialSelectedReasons[lot.sponsorLotNumber] = reason;
            }

            return {
              ...lot,
              reasonForDifference: reason,
              onHandQtyDifferencePercentage: lot?.sponsorOnHandAvailableQuantity
                ? //  Math.abs(
                  //     Math.round(
                  //       (lot.onHandQuantityDifference /
                  //         item.totalOnHandQtySponsor) *
                  //         100 *
                  //         100
                  //     ) / 100
                  //   )
                  (
                    (lot.onHandQuantityDifference * 100) /
                    lot.sponsorOnHandAvailableQuantity
                  ).toFixed(3)
                : 0,
              committedQtyDifferencePercentage: lot.sponsorCommittedQuantity
                ? // Math.abs(
                  //     Math.round(
                  //       (lot.committedQuantityDifference /
                  //         item.totalCommittedQtySponsor) *
                  //         100 *
                  //         100
                  //     ) / 100
                  //   )

                  (
                    (lot.committedQuantityDifference * 100) /
                    lot.sponsorCommittedQuantity
                  ).toFixed(3)
                : 0,
            };
          }
        );

        return {
          materialInfo: `${item.boMaterialCode} / ${item.materialDescription}`,
          inventoryUOM: item.inventoryUOM,
          sponsorLastUpdatedDate: item.sponsorLatestUpdateDate,
          cmoLatestUpdateDate: item.cmoLatestUpdateDate,
          totalSponsorOnHand: item.totalOnHandQtySponsor,
          totalSponsorCommitted: item.totalCommittedQtySponsor,
          totalCMOOnHand: item.totalOnHandQtyCMO,
          totalCMOCommitted: item.totalCommittedQtyCMO,
          lotNumberDetailsList: updatedLotNumberDetailsList,
        };
      }
    );

    // Apply time filter
    let filteredData = transformedData.filter((item) => {
  //     const itemDateStr =
  //  localStorage.collabType !== "CMO" ? item?.sponsorLastUpdatedDate : item?.cmoLatestUpdateDate;
      // item?.cmoLatestUpdateDate || item?.sponsorLastUpdatedDate;
      const itemDateStr =
      localStorage.getItem("collabType") !== "CMO"
        ? item?.sponsorLastUpdatedDate
        : item?.cmoLatestUpdateDate;

      if (!itemDateStr) return false;
      const localItemDateStr = convertToLocaleDateTime(itemDateStr);
      const nowStr = new Date();

const now = moment(nowStr, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
const localItemDate = moment(localItemDateStr, 'DD-MMM-YYYY HH:mm:ss');
if (isNaN(localItemDate)) return false;
        
      const timeDiffs = {
        "Past hour": 60 * 60 * 1000,
        "Past 24 hours": 24 * 60 * 60 * 1000,
        "Past week": 7 * 24 * 60 * 60 * 1000,
        "Past month": 30 * 24 * 60 * 60 * 1000,
        "Past three months": 90 * 24 * 60 * 60 * 1000,
      };
  
      if (filter?.timeStamp === "All") return true;
    // return now - localItemDate <= timeDiffs[filter?.timeStamp];
      return now.diff(localItemDate) <= timeDiffs[filter?.timeStamp];
    });

    // **Apply On Hand Qty Difference Percentage Filter**
    if (filter?.onHandQuantityDifference !== "All") {
      const qtyDiffThresholds = {
        "Less than 0.1": 0.1,
        "Less than 1": 1,
        "Less than 10": 10,
        "More than 10": 10, // Special case: more than 10
      };

      filteredData = filteredData
        .map((item) => {
          const filteredLots = item.lotNumberDetailsList.filter((lot) => {
            const differencePercentage = lot.onHandQtyDifferencePercentage || 0;

            if (filter.onHandQuantityDifference === "More than 10") {
              return differencePercentage > qtyDiffThresholds["More than 10"];
            }

            return (
              differencePercentage <
              qtyDiffThresholds[filter.onHandQuantityDifference]
            );
          });

          // Return only materials that have at least one matching lot
          return filteredLots.length > 0
            ? { ...item, lotNumberDetailsList: filteredLots }
            : null;
        })
        .filter(Boolean); // Remove null values (materials with no matching lots)
    }

    // Apply Committed Qty Difference Percentage Filter
    if (filter?.quantityCommittedDifference !== "All") {
      const qtyDiffThresholds = {
        "Less than 0.1": 0.1,
        "Less than 1": 1,
        "Less than 10": 10,
        "More than 10": 10, // Special case: more than 10
      };

      filteredData = filteredData
        .map((item) => {
          const filteredLots = item.lotNumberDetailsList.filter((lot) => {
            const differencePercentage =
              lot.committedQtyDifferencePercentage || 0;

            if (filter.quantityCommittedDifference === "More than 10") {
              return differencePercentage > qtyDiffThresholds["More than 10"];
            }

            return (
              differencePercentage <
              qtyDiffThresholds[filter.quantityCommittedDifference]
            );
          });

          // Return only materials that have at least one matching lot
          return filteredLots.length > 0
            ? { ...item, lotNumberDetailsList: filteredLots }
            : null;
        })
        .filter(Boolean); // Remove null values (materials with no matching lots)
    }

    // Apply Reason for Difference Filter
    if (filter?.reasonForDifference !== "All") {
      filteredData = filteredData
        .map((item) => {
          const filteredLots = item.lotNumberDetailsList.filter((lot) => {
            return (
              lot.reasonForDifference &&
              lot.reasonForDifference.trim() !== "" &&
              lot.reasonForDifference.trim() ===
                filter.reasonForDifference.trim()
            );
          });

          // Return only if there are remaining lots after filtering
          return filteredLots.length > 0
            ? { ...item, lotNumberDetailsList: filteredLots }
            : null;
        })
        .filter(Boolean); // Remove null values (materials with no matching lots)
    }

    setInitialSelectedReasons(initialSelectedReasons);
    setSelectedReasons(initialSelectedReasons);

    setBatchDetails(filteredData);
    };

  return {
    batchDetails,
    batchLoading,
    handleSave,
    saveDialog,
    setSaveDialog,
    batchError,
    setRefresh,
    handleReason,
    selectedReasons,
    hasChanges,
    apiData,
  };
};

export default useBatchDetails;
